import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBag3"><Path d="M21.5 20.5V6.5H2.5V20.5H21.5Z" stroke="currentColor"/><Path d="M7.5 6.5V2.5H16.5V6.5" stroke="currentColor"/><Path d="M2.5 11L12 13L21.5 11" stroke="currentColor"/><Path d="M12 12V14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBag3;
